import * as React from "react"
import { OrderedList, ListItem } from "@chakra-ui/react"

import { rawCeremonies } from "./raw-ceremonies"

export interface ICeremony {
  id: string
  name: string
  withWhom: string[]
  kind: string
}

export const ceremonies = rawCeremonies as { [key: string]: ICeremony }
export const ceremonyValues = Object.values(ceremonies).sort(function () {
  return 0.5 - Math.random()
})

export const Ceremony: React.FC<{
  withWhom: string
}> = ({ withWhom }) => {
  // @TODO These should be filtered outside of this component?
  const { rit1, rit2, ints, rules } = React.useMemo(() => {
    const rits = ceremonyValues
      .filter((c) => c.withWhom.includes(withWhom) && c.kind === "ritual")
      .map((c) => c.name)
    return {
      rit1: rits.pop(),
      rit2: rits.pop(),
      ints: ceremonyValues
        .filter((c) => c.withWhom.includes(withWhom) && c.kind === "intention")
        .map((c) => c.name),
      rules: ceremonyValues
        .filter(
          (c) => c.withWhom.includes(withWhom) && c.kind === "ground rules",
        )
        .map((c) => c.name),
    }
  }, [withWhom])

  return (
    <OrderedList>
      <ListItem>{rit1}</ListItem>
      {ints.map((int, i) => (
        <ListItem key={i}>{int}</ListItem>
      ))}
      {rules.map((rule, i) => (
        <ListItem key={i}>{rule}</ListItem>
      ))}
      <ListItem>{rit2}</ListItem>
    </OrderedList>
  )
}
